import {dateFilterParams} from '../../views/components/ag-grid/filter-params/DateComparator';

export default [
  {
    headerName : 'SubmissionDate',
    headerClass: 'header-text-wrap',
    field: 'CreatedOn',
    tooltipField: 'CreatedOn',
    tooltipComponentParams: { field: 'CreatedOn', isDate: true },
    minWidth: 160,
    maxWidth: 160,
    filter: 'agDateColumnFilter',
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
    sort: 'desc',
  },
  {
    headerName : 'Risk',
    headerClass: 'header-text-wrap',
    filter: 'agSetColumnFilter',
    minWidth: 100,
    width: 100,
    field: 'Risk',
    tooltipField: 'Risk',
    tooltipComponentParams: { field: 'Risk'},
  },
  {
    headerName : 'ClassOfBusiness',
    headerClass: 'header-text-wrap',
    filter: 'agSetColumnFilter',
    minWidth: 150,
    width: 150,
    field: 'ClassOfBusiness',
    tooltipField: 'ClassOfBusiness',
    tooltipComponentParams: { field: 'ClassOfBusiness'},
  },
  {
    headerName : 'Status',
    headerClass: 'header-text-wrap',
    filter: 'agSetColumnFilter',
    minWidth: 100,
    width: 100,
    field: 'Status',
    tooltipField: 'Status',
    tooltipComponentParams: { field: 'Status'},
  },
  {
    headerName : 'Broker',
    headerClass: 'header-text-wrap',
    filter: 'agSetColumnFilter',
    minWidth: 100,
    width: 100,
    field: 'Broker',
    tooltipField: 'Broker',
    tooltipComponentParams: { field: 'Broker'},
  },
  {
    headerName : 'Type',
    headerClass: 'header-text-wrap',
    filter: 'agSetColumnFilter',
    minWidth: 100,
    width: 100,
    field: 'Type',
    tooltipField: 'Type',
    tooltipComponentParams: { field: 'Type'},
  },
  {
    headerName : 'FacilityReference',
    headerClass: 'header-text-wrap',
    filter: 'agSetColumnFilter',
    minWidth: 150,
    width: 150,
    field: 'FacilityReference',
    tooltipField: 'FacilityReference',
    tooltipComponentParams: { field: 'FacilityReference'},
  },
  {
    headerName : 'Section',
    headerClass: 'header-text-wrap',
    filter: 'agSetColumnFilter',
    minWidth: 100,
    width: 100,
    field: 'Section',
    tooltipField: 'Section',
    tooltipComponentParams: { field: 'Section'},
  },
  {
    headerName : 'QuotationCode',
    headerClass: 'header-text-wrap',
    field: 'TicketPK',
    tooltipField: 'TicketPK',
    tooltipComponentParams: { field: 'TicketPK'},
    minWidth: 135,
    maxWidth: 160,
  },
];

